import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class CertificatesList extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h2>CERTIFICATE NAMES LIST</h2>
      <br />
      <br />
      <h3>10 KYU</h3>
      <br />
      <br />
      <div><Link to='/conduct-nattawuta'>1. AAT  6233  MR.NATTAWUT ASSARASRI</Link></div>
      <br />
      <div><Link to='/conduct-narat'>2. AAT  8033  MS.NARA TAKIGUCHI</Link></div>
      <br />
      <div><Link to='/conduct-praphatpongy'>3. AAT  8038  MR.PRAPHATPONG YOODEE</Link></div>
      <br />
      <div><Link to='/conduct-nichaj'>4. AAT  8039  MS.NICHA JAMJUN</Link></div>
      <br />
      <div><Link to='/conduct-naras'>5. AAT  8040  MR.NARA  SINGHSATHITSUK</Link></div>
      <br />
      <div><Link to='/conduct-naruekarink'>6. AAT 8036  MR.NARUEKARIN KHEMARUT</Link></div>
      <br />
      <div><Link to='/conduct-carinad'>7. AAT 8037  MS.CARINA DEKE</Link></div>
      <br />
      <div><Link to='/conduct-watcharapongb'>8. AAT 8025  LT.WATCHARAPONG BUMRUNGKLANG</Link></div>
      <br />
      <div><Link to='/conduct-panyasuphak'>9. AAT 8029  MS.PANYASUPHA KHEMARUT</Link></div>
      <br />
      <div><Link to='/conduct-kank'>10. AAT 8030  MR.KAN KAIWANNON</Link></div>
      <br />
      <div><Link to='/conduct-natdanaid'>11. AAT 8031  MR.NATDANAI DOUNGRATSAMEE</Link></div>
      <br />
      <div><Link to='/conduct-athichonmf'>12. AAT 8032  MR.ATHICHONM FUANGKAEW</Link></div>
      <br />
      <div><Link to='/conduct-marcop'>13. AAT  8018  MR.MARCO PENNA</Link></div>
      <br />
      <div><Link to='/conduct-shinehl'>14. AAT  8019  MR.SHINE HTET LINN</Link></div>
      <br />
      <div><Link to='/conduct-suphatchayab'>15. AAT  8020  MS.SUPHATCHAYA BOONYASUKANON</Link></div>
      <br />
      <div><Link to='/conduct-chakchaia'>16. AAT  8022  MR.CHAKCHAI ANUPONGPAT</Link></div>
      <br />
      <div><Link to='/conduct-crystalmd'>17. AAT 8005  MS.CRYSTAL MARIE DABI</Link></div>
      <br />
      <div><Link to='/conduct-praewpuns'>18. AAT  8010  PO.PRAEWPUN SUWANNAKOT</Link></div>
      <br />
      <div><Link to='/conduct-riradav'>19. AAT  8011  PO.RIRADA VANITWORACHOT</Link></div>
      <br />
      <div><Link to='/conduct-suphodh'>20. AAT  8012  CPO.SUPHOD HARASAN</Link></div>
      <br />
      <div><Link to='/conduct-kittipatw'>21. AAT  8013  MR.KITTIPAT  WIRIYA</Link></div>
      <br />
      <div><Link to='/conduct-orawanp'>22. AAT  8014  MS.ORAWAN PONGPRUEKSAPATTANA</Link></div>
      <br />
      <div><Link to='/conduct-pats'>24. AAT  8016  MR.PAT SUTHAPUNNAKUL</Link></div>
      <br />
      <div><Link to='/conduct-naphatsorny'>25. ATT  7954  MS.NAPHATSORN  YOTSIRIPORNCHAI</Link></div>
      <br />
      <div><Link to='/conduct-nutchan'>26. ATT  7955  MS.NUTCHA  NAKAEW</Link></div>
      <br />
      <div><Link to='/conduct-matsakaj'>27. ATT  8002  MR.MATSAKA JANSAWANG</Link></div>
      <br />
      <div><Link to='/conduct-panyaphatk'>28. AAT 7961  MR.PANYAPHAT KONGSEANG</Link></div>
      <br />
      <br />
      <h3>9 KYU</h3>
      <br />
      <br />
      <div><Link to='/conduct-sirawichu'>1. AAT  8015  MR.SIRAWICH UDOMKANA</Link></div>
      <br />
      <div><Link to='/conduct-vunqt'>2. AAT  8021  MS.VU NGUYEN QUYNH TRAM</Link></div>
      <br />
      <div><Link to='/conduct-marceld'>3. AAT 8024  MR.MARCEL DEKE</Link></div>
      <br />
      <div><Link to='/conduct-andrewl'>4. AAT 7973  MR.ANDREW LINDQVIST</Link></div>
      <br />
      <div><Link to='/conduct-barbarab'>5. AAT 8027  MS.BARBARA BARZARKINA</Link></div>
      <br />
      <div><Link to='/conduct-nannaphatp'>6. AAT 8028  ​MS.NANNAPHAT PRIYACHANASAKUL</Link></div>
      <br />
      <div><Link to='/conduct-kanyaphatp'>7. AAT 8026  MS.KANYAPHAT PRIYACHANASAKUL</Link></div>
      <br />
      <div><Link to='/conduct-jamesrh'>8. AAT 8003  MR.JAMES RICKY HEBBLETHWAITE</Link></div>
      <br />
      <div><Link to='/conduct-natthapony'>9. AAT 8004  MR.NATTHAPON YATAN</Link></div>
      <br />
      <div><Link to='/conduct-nueas'>11. AAT 8006  MS.NUEA SUDRAK</Link></div>
      <br />
      <div><Link to='/conduct-manussaporne'>12. AAT  7942  MS.MANUSSAPORN EKVISIT</Link></div>
      <br />
      <div><Link to='/conduct-thongchomphunutr'>13. AAT 7887  MS.THONGCHOMPHUNUT ROJVIBOONCHAI</Link></div>
      <br />
      <div><Link to='/conduct-natsawittau'>14. AAT 7887  MS.NATSAWITTA UNGPRAPAKORN</Link></div>
      <br />
      <div><Link to='/conduct-tarah'>15. AAT 7887  MS.TARA ROSE HEBBLETHWAITE</Link></div>
      <br />
      <div><Link to='/conduct-pongworakornp'>16. ATT  7926  MR.PONGWORAKORN PAOJEEN</Link></div>
      <br />
      <div><Link to='/conduct-uraveet'>17. ATT  7896  MS.URAVEE THEPWIMOLPETCHKUL</Link></div>
      <br />
      <div><Link to='/conduct-janicej'>18. ATT  7897  MS.JANICE JAMES</Link></div>
      <br />
      <div><Link to='/conduct-panupats'>19. ATT  7924  LT.PANUPAT SANSOOK</Link></div>
      <br />
      <br />
      <h3>8 KYU</h3>
      <br />
      <br />
      <div><Link to='/conduct-karnts'>1. AAT  8007  MR.KARNT SRISUWAN</Link></div>
      <br />
      <div><Link to='/conduct-archirawishp'>2. AAT  8009  MR.ARCHIRAWISH PAKCHOTIPONG</Link></div>
      <br />
        <div><Link to='/conduct-pakawadn'>3. AAT  8008  MR.PAKAWAD NANTAJURAPLO</Link></div>
        <br />
        <br />
        <h3>7 KYU</h3>
        <br />
        <br />
        <div><Link to='/conduct-nirunc'>1. AAT 7783  LT.NIRUN CHANTAWARO</Link></div>
        <br />
        <div><Link to='/conduct-sunyal'>2. AAT 7972  CPO1.SUNYA LAEID</Link></div>
        <br />
        <div><Link to='/conduct-angieo'>3. ATT 7884  MS.ANGELICA JOSELINE OLSSON</Link></div>
        <br />
        <div><Link to='/conduct-napasanunv'>4. AAT  7951  MS.NAPASANUN VONGVIVAT</Link></div>
        <br />
        <div><Link to='/conduct-issariyapar'>5. AAT  7952  MS.ISSARIYAPA ROOPSUWANNAKUL</Link></div>
        <br />
        <div><Link to='/conduct-sreytiah'>6. AAT 7892  MS. SREYTIA HEBBLETHWAITE</Link></div>
        <br />
        <br />
        <h3>6 KYU</h3>
        <br />
        <br />
        <div><Link to='/conduct-asdawutc'>1. ATT  7925  LT.ASDAWUT CHODSAPTHAWEE</Link></div>
        <br />
        <div><Link to='/conduct-chanchita'>2. ATT  7870  MR.CHANCHIT APISAMAJAN</Link></div>
        <br />
        <br />
        <h3>5 KYU</h3>
        <br />
        <br />
        <div><Link to='/conduct-anantayak'>1. ATT  7749  MS.ANANTAYA KULTANAKORN</Link></div>
        <br />
        <div><Link to='/conduct-thomasm'>2. AAT 7923  MR.THOMAS MOENKEMEIER</Link></div>
        <br />
        <div><Link to='/conduct-napolp'>3. ATT  7910  MR.NAPOL PITAYAPAT</Link></div>
        <br />
        <div><Link to='/conduct-yanint'>4. AAT 7822  MS.YANIN TAIYANON</Link></div>
        <br />
        <br />
        <h3>4 KYU</h3>
        <br />
        <br />
        <div><Link to='/conduct-ratchadapornn'>1. AAT 7822  MS.RATCHADAPORN NONNUSAT</Link></div>
        <br />
        <br />
        <h3>3 KYU</h3>
        <br />
        <br />
        <div><Link to='/conduct-jacquesp'>1. AAT  7369  MR.JACQUES DU PLESSIS</Link></div>
        <br />
        <div><Link to='/conduct-wannatouchp'>2. AAT  7847  MR.WANNATOUCH PRASERT</Link></div>
        <br />
        <br />
        <h3>2 KYU</h3>
        <br />
        <br />
        <div><Link to='/conduct-niwats'>1. ATT  6670  MR.NIWAT SEESANGNGAM</Link></div>
        <br />
        <div><Link to='/conduct-thakhunk'>2. AAT  6514  MR.THAKHUN KAEWISALAPRAN</Link></div>
        <br />
        <br />
        <h3>1 KYU</h3>
        <br />
        <br />
        <div><Link to='/conduct-metapornc'>1. AAT 7833  MS.METAPORN CHIM-IM</Link></div>
        <br />
        <div><Link to='/conduct-kanokphonc'>2. AAT 7779  MS.KANOKPHON CHAIYAWONG</Link></div>
        <br />
        <div><Link to='/conduct-supachais'>3. AAT 7832  CPO1.SUPACHAI SITTIRUK</Link></div>
        <br />
        <div><Link to='/conduct-rattapongp'>4. AAT 4478  LT.RATTAPONG PONGSUWAN</Link></div>
        <br />
        <div><Link to='/conduct-autp'>5. AAT 7761  CDR.AUT PANGPASSA</Link></div>
        <br />
        <br />
        <h3>SHODAN-HO</h3>
        <br />
        <br />
        <div><Link to='/conduct-ekasitw'>1. AAT  1187  MR.EKASIT WIPULANUSAT</Link></div>
        <br />
        <div><Link to='/conduct-santis'>2. AAT  7518  MR.SANTI SIRISAK</Link></div>
        <br />
        <div><Link to='/conduct-pawanratc'>3. ATT  7731  MS.PAWANRAT CHUPINIJSAK</Link></div>
        <br />
        <div><Link to='/conduct-jarunnops'>4. AAT 7561  MR.JARUNNOP SIRIVORAPAIBOON</Link></div>
        <br />
        <div><Link to='/conduct-chaiyutv'>5. AAT  8017  MAJ.GEN CHAIYUT VAJIRAVARABHAKTI</Link></div>
        <br />
        <div><Link to='/conduct-suteed'>6. AAT  8023  COL.SUTEE DUANGTOON</Link></div>
        <br />
        <div><Link to='/conduct-surachett'>7. AAT  7541  MR.SURACHET THAREEPHUT</Link></div>
        <br />
        <div><Link to='/conduct-nitchakarnt'>8. AAT 7759  CPO1.NITCHAKARN THAWORNKAN</Link></div>
        <br />
        <div><Link to='/conduct-sanphets'>9. AAT 7761  CPO.SANPHET SUKPRATHUEANG</Link></div>
        <br />
        <br />
        <h3>SHODAN</h3>
        <br />
        <br />
        <div><Link to='/conduct-ronbanchoba'>1. ATT  7645  MR.RONBANCHOB APIRATIKUL</Link></div>
        <br />
        <br />
        <h3>SANDAN</h3>
        <br />
        <br />
        <div><Link to='/conduct-wacharapongs'>1. AAT 0467  RADM.WACHARAPONG SASITHORN</Link></div>
        <br />
        <div><Link to='/conduct-teerayutp'>2. AAT 2471  CAPT.TEERAYUT PAKDEEPAK</Link></div>
        <br />
        <div><Link to='/conduct-tanapolp'>3. AAT 7864  RADM.TANAPOL PITAYAPAT</Link></div>
        <br />
        <div><Link to='/conduct-naruporns'>4. AAT  2339  MR.NARUPORN  SAOWANIT</Link></div>
        <br />
        <div><Link to='/conduct-pongnarts'>5. AAT  6856  MR.PONGNART SAPSOMPONG </Link></div>
        <br />
        <br />
        <div>
        Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default CertificatesList;
